import { uebersetze } from '../../i18n/sprache.js';

/**
 * Shimmering placeholder shown while list/dashboard data loads.
 * variant 'table'  → stacked text lines (use inside .table-wrap)
 * variant 'cards'  → metric-card shaped blocks (use in place of a card grid)
 */
export function Skeleton({ variant = 'table', count = 6 }) {
  if (variant === 'cards') {
    return (
      <div className="skeleton-cards" role="status" aria-label={uebersetze('aria.laedt')}>
        {Array.from({ length: count }, (_, i) => (
          <div key={i} className="skeleton-card">
            <span className="skeleton-line" />
            <span className="skeleton-line" />
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className="skeleton-table" role="status" aria-label={uebersetze('aria.laedt')}>
      {Array.from({ length: count }, (_, i) => (
        <span key={i} className="skeleton-line" />
      ))}
    </div>
  );
}
